import React from 'react';
import NextLink from 'next/link';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  link: {
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      color: props =>
        props.hoverEffect ? theme.palette.primary.main : 'inherit',
    },
  },
});

const Link = withStyles(styles)(({ children, classes, theme, ...props }) => (
  <NextLink {...props}>
    <a className={classes.link}>{children}</a>
  </NextLink>
));

export default Link;
